import { useNavigate } from "react-router-dom";
import { Button, List, Typography } from "antd";

import { readFile } from "../../../providers/useCapacitorStorage";
import currentLocation from "../../../providers/currentLocation";
import { userData } from "../../../providers/companyInfo";

export default function SurveyList(props) {
	const { formList } = props;

	const navigate = useNavigate();

	if (formList && formList.length) {
		return (
			<List
				bordered
				dataSource={formList}
				renderItem={(item, index) => {
					// console.log("items item: ", item);
					return (
						<List.Item className={index !== formList.length - 1 ? "mb-10" : ""}>
							<div className="wrapper-content">
								<div className="content">
									<Typography.Text>{item.form_name}</Typography.Text>
								</div>

								<div className="action">
									<Button
										className="btn-add-tertiary"
										// disabled={item.answered}
										onClick={async () => {
											// if (item.answered) return;

											try {
												const currentLocations = await currentLocation();
												if (currentLocations) {
													localStorage.setItem(
														"currentLocation",
														JSON.stringify(currentLocations),
													);
												}
											} catch (error) {
												console.warn("Error getting current location: ", error);
											}

											try {
												let survey_pending_list = await readFile(
													`fsuu_dsac_survey_diosys/survey_pending_list_${
														userData().id
													}.txt`,
												);

												let lastIndex = 1;

												if (survey_pending_list && survey_pending_list.data) {
													let surveyPendingList = JSON.parse(
														survey_pending_list.data,
													);

													if (surveyPendingList && surveyPendingList.length) {
														lastIndex += surveyPendingList.length + 1;
													}
												}
												navigate(`/survey/add/${item.id}/${lastIndex}`);
											} catch (error) {
												console.warn(
													"Error reading survey_pending_list.txt: ",
													error,
												);
												navigate(`/survey/add/${item.id}/1`);
											}
										}}
									>
										Take Survey
									</Button>
								</div>
							</div>
						</List.Item>
					);
				}}
			/>
		);
	} else {
		return (
			<div className="div-no-survey-list">
				<div className="content">No Survey Available</div>
			</div>
		);
	}
}
